var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.357 17.643C53.6588 18.9447 53.6588 21.0553 52.357 22.357L34.7141 40L52.357 57.643C53.6588 58.9447 53.6588 61.0553 52.357 62.357C51.0553 63.6588 48.9447 63.6588 47.643 62.357L27.643 42.357C26.3413 41.0553 26.3413 38.9447 27.643 37.643L47.643 17.643C48.9447 16.3412 51.0553 16.3412 52.357 17.643Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.7476194de88d63953b4e4f8b92131822.svg";
export { ForwardRef as ReactComponent };